import { createFileRoute, Link } from "@tanstack/react-router";
import { PageHero } from "@/components/page-hero";
import heroImg from "@/assets/dj-mariage-equipment.jpg";
import { trackEvent } from "@/lib/analytics";
import { metaDesc } from "@/lib/seo-description";

export const Route = createFileRoute("/mentions-legales")({
  head: () => ({
    meta: [
      { title: "Mentions légales | DJ Val" },
      { name: "description", content: metaDesc("Mentions légales du site dj-val.fr : identité de l'éditeur DJ Val, hébergeur, propriété intellectuelle, responsabilité, données et contact direct.") },
      { name: "robots", content: "index,follow" },
      { property: "og:title", content: "Mentions légales — DJ Val" },
      { property: "og:url", content: "https://dj-val.fr/mentions-legales" },
    ],
    links: [{ rel: "canonical", href: "https://dj-val.fr/mentions-legales" }],
  }),
  component: Page,
});

function Page() {
  return (
    <div className="bg-background text-muted-foreground">
      <PageHero
        image={heroImg}
        eyebrow="Informations légales"
        title={<>Mentions <span className="italic">légales</span></>}
        subtitle="Éditeur, hébergeur, propriété intellectuelle et coordonnées de l'entreprise DJ Val."
        height="compact"
      />
      <section className="py-16 px-6 max-w-3xl mx-auto">
        <div className="space-y-8 text-sm leading-relaxed font-light">

          <div>
            <h2 className="font-serif-display text-xl text-foreground mb-3">Éditeur du site</h2>
            <p>
              <strong className="text-foreground">DJ VAL – By Orcet Stéphane</strong><br />
              Entreprise individuelle (micro-entreprise)<br />
              106 Grand Rue, 84300 Cavaillon, France<br />
              Téléphone : <a href="tel:0767908667" onClick={() => trackEvent("contact_click", { contact_method: "tel", cta_location: "mentions_legales" })} className="text-[var(--gold)] hover:underline">07 67 90 86 67</a><br />
              E-mail : <a href="mailto:info.djval@gmail.com" onClick={() => trackEvent("contact_click", { contact_method: "email", cta_location: "mentions_legales" })} className="text-[var(--gold)] hover:underline">info.djval@gmail.com</a><br />
              SIREN : 510 034 416<br />
              SIRET (siège) : 510 034 416 00030<br />
              N° TVA intracommunautaire : FR40510034416 — <em>TVA non applicable, art. 293 B du CGI</em><br />
              RCS Avignon : 510 034 416 R.C.S. Avignon (inscrit le 16/05/2023)<br />
              Inscription au RNE : inscrit<br />
              Directeur de la publication : Stéphane Orcet
            </p>
          </div>


          <div>
            <h2 className="font-serif-display text-xl text-foreground mb-3">Hébergement</h2>
            <p>
              Le site dj-val.fr est hébergé par <strong className="text-foreground">Lovable</strong> (servi via Cloudflare).<br />
              Site : <a href="https://lovable.dev" onClick={() => trackEvent("outbound_click", { link_url: "https://lovable.dev", cta_location: "mentions_legales" })} target="_blank" rel="noopener noreferrer" className="text-[var(--gold)] hover:underline">lovable.dev</a>
            </p>
          </div>

          <div>
            <h2 className="font-serif-display text-xl text-foreground mb-3">Propriété intellectuelle</h2>
            <p>
              L'ensemble du contenu du site (textes, photographies, vidéos, logos, charte graphique) est la propriété
              exclusive de DJ Val ou de ses partenaires, et protégé par le droit d'auteur. Toute reproduction, même
              partielle, est interdite sans autorisation écrite préalable.
            </p>
          </div>

          <div>
            <h2 className="font-serif-display text-xl text-foreground mb-3">Crédits photos</h2>
            <p>
              Photographies des prestations : © DJ Val. Photographies d'illustration : Unsplash et photographes
              partenaires (crédits sur demande).
            </p>
          </div>

          <div>
            <h2 className="font-serif-display text-xl text-foreground mb-3">Données personnelles</h2>
            <p>
              Les informations transmises via le formulaire de contact sont uniquement utilisées pour répondre à votre
              demande de devis. Voir notre{" "}
              <Link to="/politique-confidentialite" className="text-[var(--gold)] hover:underline">
                politique de confidentialité
              </Link>{" "}
              pour le détail.
            </p>
          </div>

          <div>
            <h2 className="font-serif-display text-xl text-foreground mb-3">Droits SACEM</h2>
            <p>
              DJ Val est à jour de ses déclarations SACEM pour la diffusion de musique enregistrée dans le cadre
              d'événements privés et professionnels. L'attestation peut être fournie sur demande.
            </p>
          </div>

          <div>
            <h2 className="font-serif-display text-xl text-foreground mb-3">Litiges</h2>
            <p>
              Le présent site est soumis au droit français. En cas de litige, et après tentative de résolution amiable,
              les tribunaux compétents seront ceux du ressort du siège de l'entreprise.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
